import { ref } from "vue";

/*********************************************************************/
//                       NON-REACTIVE CONSTANTS                      //
/*********************************************************************/
import { createDefaultLogger } from "@/types/console-logger";
const logger = createDefaultLogger();

/*********************************************************************/
//                 GLOBALLY SHARED REACTIVE VARIABLES                //
/*********************************************************************/
// The page size reactive variable is used as a paging aid when calculating the index for the
// start of the currently selected page of data
const pageSize = ref< number >( 8 );

// The page number reactive variable is partially controlled by the paging component which is
// why it is used as the v-model for the paging component
const pageNumber = ref< number >( 0 );

/*********************************************************************/
//                      INSTANCE SPECIFIC STATE
/*********************************************************************/
export function usePagingFilter() {
    function filteredContentPage< T >( content: T[] ): T[] {
        // Guard against stale offsets when filters shrink the result set.
        // Example: on page 3, then applying a filter with only one page left.
        if ( pageNumber.value < 0 || pageNumber.value >= content.length ) {
            pageNumber.value = 0;
        }

        // Skip the number of items as the page size * 1 - the page #
        const fromInclusive: number = pageNumber.value;
        logger.debug( '[ paging-filter ].filteredContentPage -> fromInclusive: ', fromInclusive );
        const toExclusive: number = fromInclusive + pageSize.value;
        logger.debug( '[ paging-filter ].filteredContentPage -> toExclusive: ', toExclusive );

        logger.debug( '[ paging-filter ].filteredContentPage -> filteredContentPage: ', content );

        return content.slice( fromInclusive, toExclusive );
    }

    function resetPageNumber() {
        pageNumber.value = 0;
    }

    return {
        // ACTIONS
        filteredContentPage,
        resetPageNumber,

        // GETTERS
        pageNumber,
        pageSize
    }
}

export type PagingFilter = ReturnType< typeof usePagingFilter >;
